import styled from "styled-components";

export const RadioButton = styled.button`
    position: relative;
    width: min(100%, 363px);
    min-height: 50px;
    height: 50px;
    border: 1px solid #C9D2E7;
    border-radius: 8px;
    text-align: left;
    padding-left: 20px;
    font-family: Manrope, Helvetica, sans-serif;
    box-shadow: none;
    font-weight: 400;
    cursor: pointer;
    background-color: ${(props) => (props.active ? "rgba(91, 110, 245, 0.12)" : "#F3F5FB")};
    color: #171A22;
    font-weight: ${(props) => (props.active ? "700" : "400")};
    box-sizing: border-box;
    transition: border-color 0.16s ease, box-shadow 0.16s ease, background 0.16s ease;

    &:hover {
        border-color: #171A22;
    }
`;

export const CheckMark = styled.span`
    color: white;
    font-size: 10px;
`;

export const SquareBox = styled.div`
    position: absolute;
    top: 15px;
    right: 15px;
    width: 17px;
    height: 17px;
    border-radius: 4px;
    border: ${(props) => (props.active ? "2px solid #171A22" : "1px solid #8A95AB")};
    background: ${(props) => (props.active ? "#171A22" : "transparent")};
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 1;
`;
